import MuiButton from "./../components/basicComponent/MuiButton";
import Header from "./../sharedScreens/Header";
import SideMenu from "./../sharedScreens/menuItems/SideMenu";
import React, { useState } from "react";
import { MuiInput } from "./../components/basicComponent/MuiInput";
import MuiRadioButton from "./../components/basicComponent/MuiRAdioButton";
import { Checkbox } from "@mui/material";
import { FormikHelpers, useFormik } from "formik";
import { ChangePasswordvalidationSchema } from "./../validations/Schema";
import { UtilService } from "./../services/shared/UtilService";
import { useSweetAlert } from "./../services/customHooks/useSweetAlert";
import { msgTypes } from "./../constants/msgTypes";
import { Visibility, VisibilityOff } from "@mui/icons-material";

interface ChangePasswordFormValues {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

const Changepassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const { showSuccess, showError } = useSweetAlert();

  const initialValues: ChangePasswordFormValues = {
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  };

  const formik = useFormik<ChangePasswordFormValues>({
    initialValues,
    validationSchema: ChangePasswordvalidationSchema,
    onSubmit: async (
      values: ChangePasswordFormValues,
      { resetForm }: FormikHelpers<ChangePasswordFormValues>
    ) => {
      try {
        const payload = {
          old_password: values.oldPassword,
          new_password: values.newPassword,
          confirm_password: values.confirmPassword,
        };

        const response = await UtilService.changePassword(payload);
        if (response?.statusMsg === msgTypes.SUCCESS.msg) {
          showSuccess(
            "Success!",
            "Your password has been changed successfully.",
            {
              timer: 3000,
              timerProgressBar: true,
            }
          ).then(() => {
            formik.resetForm();
          });
        }
      } catch (error: any) {
        console.error("Error:", error);
      }
    },
  });

  return (
    <>
      <div className="grow">
        <SideMenu />
        <div className="wrapper flex grow flex-col">
          <Header />
          <main className="grow content" id="content" role="content">
            <div className="container-fixed">
              <div className="card-header mb-1 ">
                <h3 className="card-title titlecolorr">Change Password</h3>
              </div>
              <div className="card changepass-card">
                <div className="card-body">
                  <div className="row mt-3">
                    <div className="col-md-4 my-under-500">
                      <MuiInput
                        type={showPassword ? "text" : "password"}
                        placeholder="Old Password"
                        label={"Old Password"}
                        isRequired={true}
                        name="oldPassword"
                        value={formik.values.oldPassword}
                        onChange={(value) =>
                          formik.setFieldValue("oldPassword", value)
                        }
                        onBlur={formik.handleBlur}
                        error={
                          !!(
                            formik.touched.oldPassword &&
                            formik.errors.oldPassword
                          )
                        }
                        helperText={
                          formik.touched.oldPassword &&
                          formik.errors.oldPassword
                        }
                      />
                    </div>

                    <div className="col-md-4 my-under-500">
                      <MuiInput
                        type={showPassword ? "text" : "password"}
                        placeholder="New Password"
                        label={"New Password"}
                        isRequired={true}
                        name="newPassword"
                        value={formik.values.newPassword}
                        error={
                          !!(
                            formik.touched.newPassword &&
                            formik.errors.newPassword
                          )
                        }
                        onChange={(value) =>
                          formik.setFieldValue("newPassword", value)
                        }
                        onBlur={formik.handleBlur}
                        helperText={
                          formik.touched.newPassword &&
                          formik.errors.newPassword
                        }
                      />
                    </div>

                    <div className="col-md-4 my-under-500">
                      <MuiInput
                        type={showPassword ? "text" : "password"}
                        placeholder="Confirm Password "
                        label={"Confirm Password "}
                        isRequired={true}
                        name="confirmPassword"
                        value={formik.values.confirmPassword}
                        error={
                          !!(
                            formik.touched.confirmPassword &&
                            formik.errors.confirmPassword
                          )
                        }
                        onChange={(value) =>
                          formik.setFieldValue("confirmPassword", value)
                        }
                        onBlur={formik.handleBlur}
                        helperText={
                          formik.touched.confirmPassword &&
                          formik.errors.confirmPassword
                        }
                      />
                    </div>

                    <div className="row d-flex justify-content-end">
                      {/* <div className="col-md-10">
                        <p className="text-danger mt-2 mb-0 tx-12 tx-medium">
                          <strong>Note:</strong>
                          Password should be Minimum of 7–15 characters and it
                          should contain mixed case letters, one upper case,
                          numeric values and special characters (
                          <span className="fw-bold">!, #, $, *, _, @</span>).
                        </p>
                      </div> */}
                      <div className="col-md-2 d-flex justify-content-end">
                        <div className="showmore">
                          <Checkbox
                            checked={showPassword}
                            onChange={(e) => setShowPassword(e.target.checked)}
                          />
                          Show Password
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="user-button w-full">
                    <MuiButton
                      className="clear-btn"
                      label=" Clear"
                      type="submit"
                      onClick={() => formik.resetForm()}
                    />
                    <MuiButton
                      className="get-btn"
                      label="Save"
                      onClick={() => formik.handleSubmit()}
                      type="submit"
                    />
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default Changepassword;
